import type { ProviderFormatSettings, ProviderFormatOption } from './types';

export const defaultProviderFormatSettings: ProviderFormatSettings = {
  date_formats: {
    date: 'dd/MM/yyyy',
    datetime: 'HH:mm:ss dd/MM/yyyy',
    yearmonth: 'MM/yyyy',
    separator: '/',
  },
  numeric_formats: {
    thousands_separator: ',',
    decimal_separator: '.',
    decimal_places: 2,
    negative_sign: 'minus',
    currency: '$',
    currency_position: 'before',
  },
};

export const providerDataSettingsOptions = {
  thousandsSeparator: [
    { label: 'No Format', value: '' },
    { label: 'Comma (,)', value: ',' },
    { label: 'Space ( )', value: ' ' },
    { label: 'Period (.)', value: '.' },
  ] satisfies Array<ProviderFormatOption<'thousands_separator'>>,
  decimalSeparator: [
    { label: 'Period (.)', value: '.' },
    { label: 'Comma (,)', value: ',' },
  ] satisfies Array<ProviderFormatOption<'decimal_separator'>>,
  decimalPlaces: [
    { label: '0', value: 0 },
    { label: '1', value: 1 },
    { label: '2', value: 2 },
  ] satisfies Array<ProviderFormatOption<'decimal_places'>>,
  negativeSign: [
    { label: 'Negative Sign (-)', value: 'minus' },
    { label: 'Parenthesis ( )', value: 'parentheses' },
  ] satisfies Array<ProviderFormatOption<'negative_sign'>>,
  currencySymbol: [
    { label: 'No format', value: '' },
    { label: 'United States - USD - $', value: '$' },
    { label: 'European Union - EUR - €', value: '€' },
    { label: 'United Kingdom - GBP - £', value: '£' },
  ] satisfies Array<ProviderFormatOption<'currency'>>,
  currencyPosition: [
    { label: 'Prefix', value: 'before' },
    { label: 'Suffix', value: 'after' },
  ] satisfies Array<ProviderFormatOption<'currency_position'>>,
  dateDelimiter: [
    { label: 'Slash (/) ', value: '/' },
    { label: 'Hyphen (-)', value: '-' },
    { label: 'Period (.)', value: '.' },
  ] satisfies Array<ProviderFormatOption<'separator'>>,
  dateFormat: [
    { label: 'mm/dd/yyyy', value: 'MM/dd/yyyy' },
    { label: 'dd/mm/yyyy', value: 'dd/MM/yyyy' },
    { label: 'yyyy/dd/mm', value: 'yyyy/dd/MM' },
    { label: 'yyyy/mm/dd', value: 'yyyy/MM/dd' },
  ] satisfies Array<ProviderFormatOption<'date'>>,
  yearMonthFormat: [
    { label: 'mm/yyyy', value: 'MM/yyyy' },
    { label: 'yyyy/mm', value: 'yyyy/MM' },
  ] satisfies Array<ProviderFormatOption<'yearmonth'>>,
};
